import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Header from '../Components/header/Header'; // 引入 Header 组件
import Footer from '../Components/footer/Footer'; // 引入 Footer 组件

const Terms = () => {
  return (
    <div 
      style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        backgroundColor: '#fff', // 黑色背景
        color: '#000' // 白色字体
      }}
    >
      <Header />
      <Box 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          paddingY: '100px' // 上下间距
        }}
      >
        <Container maxWidth="md">
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ 
              fontWeight: 'bold', 
              textAlign: 'center', 
              marginBottom: '40px' 
            }}
          >
            Terms & Conditions
          </Typography>

          <Typography variant="body1" paragraph>
            Welcome to Spring Creek! These terms and conditions outline the rules and regulations 
            for the use of our website and services. By accessing this website, we assume you accept 
            these terms and conditions in full. Do not continue to use Spring Creek’s website if you 
            do not accept all the terms and conditions stated on this page.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', marginTop: '20px' }}
          >
            1. License
          </Typography>
          <Typography variant="body1" paragraph>
            Unless otherwise stated, Spring Creek and/or its licensors own the intellectual property 
            rights for all material on the website. All intellectual property rights are reserved. You 
            may view and/or print pages for personal use, subject to restrictions set in these terms 
            and conditions.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', marginTop: '20px' }}
          >
            2. Limitations of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            In no event shall Spring Creek or its suppliers be liable for any damages (including, 
            without limitation, damages for loss of data or profit) arising out of the use or inability 
            to use the materials on this site.
          </Typography>

          <Typography 
            variant="h6" 
            gutterBottom 
            sx={{ fontWeight: 'bold', marginTop: '20px' }}
          >
            3. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to revise these terms at any time without prior notice. By using this 
            website, you agree to be bound by the current version of these Terms and Conditions.
          </Typography>
        </Container>
      </Box>
      <Footer />
    </div>
  );
};

export default Terms;